export default "__VITE_ASSET__ClQ2HKK0__"